import { createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
  IDLE: "idle",
  ERROR: "error",
  LOADING: "loading",
});

const UserSlice = createSlice({
  name: "User",
  initialState: {
    UserData: {},
    CoursesData: {},
    UserInfo: [],
    IsLoggedin: false,
    status: STATUSES.IDLE,
  },
  reducers: {
    SetUserData: (state, action) => {
      state.UserData = {
        ...state.UserData,
        ...action.payload,
      };
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    SetLoggedin: (state, action) => {
      state.IsLoggedin = action.payload;
    },
    SetUserInfo: (state, action) => {
      state.UserInfo = action.payload;
    },
    SetCoursesData: (state, action) => {
      state.CoursesData = action.payload;
    },
    SetClearUserData: (state, action) => {
      state.UserData = {};
      state.CoursesData = {};
      state.UserInfo = [];
      state.IsLoggedin = false;
      state.status = STATUSES.IDLE;
    },
  },
});

export default UserSlice.reducer;
export const {
  SetUserData,
  setStatus,
  setLoginData,
  SetCoursesData,
  SetUserInfo,
  SetLoggedin,
  SetClearUserData,
} = UserSlice.actions;
